import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { BarChart } from '@mui/x-charts';
import { useTheme } from '@mui/material/styles';

/**
 * @component TimeToOpenChart
 * @description Horizontal bar chart showing time to open distribution
 * Uses same styling and layout as FunnelChart
 * @param {Object} props
 * @param {Object} props.timeToOpen - Time to open distribution object with within1Hour, within6Hours, within24Hours, within48Hours, after48Hours
 * @param {boolean} [props.loading=false] - Loading state
 * @param {number} [props.height=200] - Chart height
 * @returns {JSX.Element}
 */
export function TimeToOpenChart({ 
  timeToOpen = {},
  loading = false,
  height = 200 
}) {
  const theme = useTheme();

  // Prepare data for horizontal bar chart - always show all 5 time buckets
  const stages = [
    { label: '<1 Hour', value: timeToOpen.within1Hour || 0 },
    { label: '<6 Hours', value: timeToOpen.within6Hours || 0 },
    { label: '<24 Hours', value: timeToOpen.within24Hours || 0 },
    { label: '<48 Hours', value: timeToOpen.within48Hours || 0 },
    { label: '>48 Hours', value: timeToOpen.after48Hours || 0 },
  ];

  if (loading) {
    return (
      <Paper variant="outlined" sx={{ p: 2, textAlign: 'center', minHeight: height }}>
        <Typography variant="body2" color="text.secondary">
          Loading...
        </Typography>
      </Paper>
    );
  }

  return (
    <Box>
      <BarChart
        layout="horizontal"
        margin={{ left: 80 }}
        yAxis={[
          {
            data: stages.map(s => s.label),
            scaleType: 'band',
          },
        ]}
        series={[
          {
            data: stages.map(s => s.value),
            color: theme.palette.primary.main,
          },
        ]}
        height={height}
        sx={{
          '& .MuiChartsAxis-root': {
            fontSize: '0.75rem',
          },
          '& .MuiChartsBarElement-root rect': {
            rx: '4px',
            ry: '4px',
          },
        }}
      />
    </Box>
  );
}

